import { render } from "./PageOpenBanners.vue?vue&type=template&id=52c002df&scoped=true"
import script from "./PageOpenBanners.vue?vue&type=script&lang=js"
export * from "./PageOpenBanners.vue?vue&type=script&lang=js"

import "./PageOpenBanners.vue?vue&type=style&index=0&id=52c002df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c002df"]])

export default __exports__